import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { useYardStores } from '@yard/AppProvider'
import { observer } from 'mobx-react-lite'
import ContainerLengthBayMappingForm from '../forms/container-length-bay-mapping-form/ContainerLengthBayMappingForm'
import { ContainerLengthBayMappingSubmitProfile } from '../forms/container-length-bay-mapping-form/container-length-bay-mapping-form.profile'

const ContainerLengthBayMappingsTableDialog = observer(() => {
  const { t } = useTranslate()
  const { containerLengthBayMappingsTableUIStore } = useYardStores()
  const formId = 'container-length-bay-mapping-form'

  const handleOnClose = () => containerLengthBayMappingsTableUIStore.closeDialog()
  const handleOnSubmit = async (formValues: ContainerLengthBayMappingSubmitProfile) =>
    await containerLengthBayMappingsTableUIStore.save(formValues, handleOnClose)

  return (
    <ConfirmationDialog
      open={containerLengthBayMappingsTableUIStore.isDialogOpen}
      title={
        containerLengthBayMappingsTableUIStore.dialogEntity
          ? t('editContainerLengthBayMapping', 'Edit container length mapping')
          : t('addContainerLengthBayMapping', 'Add container length mapping')
      }
      primaryActionText={t('save', 'Save')}
      closeLabel={t('cancel', 'Cancel')}
      formId={formId}
      maxWidth='xs'
      onClose={handleOnClose}
      hasBorderTop
    >
      {containerLengthBayMappingsTableUIStore.isDialogOpen && (
        <ContainerLengthBayMappingForm
          id={formId}
          onSubmit={handleOnSubmit}
          mapping={containerLengthBayMappingsTableUIStore.dialogEntity}
          existingLengths={containerLengthBayMappingsTableUIStore.existingLengths}
        />
      )}
    </ConfirmationDialog>
  )
})

export default ContainerLengthBayMappingsTableDialog
